var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "user-manage" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "div",
            { staticClass: "handle-box" },
            [
              _c(
                "el-form",
                {
                  ref: "queryCondition",
                  attrs: {
                    model: _vm.queryCondition,
                    "label-position": _vm.labelPosition,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("sys.userList.userName"),
                                prop: "name",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                staticStyle: { width: "100%" },
                                model: {
                                  value: _vm.queryCondition.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryCondition, "name", $$v)
                                  },
                                  expression: "queryCondition.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("sys.userList.userCd"),
                                prop: "emplid",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                staticStyle: { width: "100%" },
                                model: {
                                  value: _vm.queryCondition.emplid,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryCondition, "emplid", $$v)
                                  },
                                  expression: "queryCondition.emplid",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("sys.userList.supplierCode"),
                                prop: "supplierCode",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                staticStyle: { width: "100%" },
                                model: {
                                  value: _vm.queryCondition.supplierCode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryCondition,
                                      "supplierCode",
                                      $$v
                                    )
                                  },
                                  expression: "queryCondition.supplierCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("sys.userList.email"),
                                prop: "email",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                staticStyle: { width: "100%" },
                                model: {
                                  value: _vm.queryCondition.email,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryCondition, "email", $$v)
                                  },
                                  expression: "queryCondition.email",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("sys.userList.userType"),
                                prop: "emplFlag",
                              },
                            },
                            [
                              _c("ic-select", {
                                staticStyle: { width: "100%" },
                                attrs: { table: "TM_USER", field: "USER_TYPE" },
                                model: {
                                  value: _vm.queryCondition.emplFlag,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryCondition,
                                      "emplFlag",
                                      $$v
                                    )
                                  },
                                  expression: "queryCondition.emplFlag",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "创建时间从",
                                prop: "createDateFrom",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm:ss",
                                  type: "datetime",
                                },
                                model: {
                                  value: _vm.queryCondition.createDateFrom,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryCondition,
                                      "createDateFrom",
                                      $$v
                                    )
                                  },
                                  expression: "queryCondition.createDateFrom",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "创建时间至",
                                prop: "createDateTo",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm:ss",
                                  type: "datetime",
                                },
                                model: {
                                  value: _vm.queryCondition.createDateTo,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryCondition,
                                      "createDateTo",
                                      $$v
                                    )
                                  },
                                  expression: "queryCondition.createDateTo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { type: "flex", justify: "center" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.queryData(1)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.search")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.restQueryForm()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.reset")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.UserSyscUserFromPortal,
                      expression: "UserSyscUserFromPortal",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.syncBossUser },
                },
                [_vm._v("同步BOSS用户")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticStyle: { "margin-top": "20px" },
              attrs: {
                data: _vm.tableData,
                border: "",
                "highlight-current-row": "",
                "max-height": "450",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  fixed: "",
                  sortable: "",
                  prop: "name",
                  label: _vm.$t("sys.userList.userName"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  fixed: "",
                  prop: "emplid",
                  label: _vm.$t("sys.userList.userCd"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  fixed: "",
                  prop: "pid",
                  label: "人员编码",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  fixed: "",
                  prop: "supplierCode",
                  label: _vm.$t("sys.userList.supplierCode"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "email",
                  label: _vm.$t("sys.userList.email"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "phone",
                  label: _vm.$t("sys.userList.phone"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "userWorkLanguage",
                  label: _vm.$t("sys.userList.Language"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            scope.row.userWorkLanguage == "zh_CN"
                              ? "中文"
                              : "英文"
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "role",
                  label: _vm.$t("sys.userList.userType"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            _vm._f("ic")(
                              scope.row.haveStore == "Y"
                                ? "STORE"
                                : scope.row.emplFlag,
                              "TM_USER",
                              "USER_TYPE"
                            )
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "isAllowLoginSystem",
                  label: "人员状态",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            _vm._f("ic")(
                              scope.row.isAllowLoginSystem,
                              "TM_USER",
                              "IS_ALLOW_LOGIN_SYSTEM"
                            )
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "createDate",
                  label: "创建时间",
                },
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("common.operation"), width: "180px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "acl",
                                rawName: "v-acl",
                                value: _vm.UserEdit,
                                expression: "UserEdit",
                              },
                            ],
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.editUserInfo(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.edit")))]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "acl",
                                rawName: "v-acl",
                                value: _vm.UserRoleAdd,
                                expression: "UserRoleAdd",
                              },
                            ],
                            attrs: { type: "primary", size: "mini" },
                            nativeOn: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.userRoleEdit(scope.row.tmUserId)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("sys.userList.addRole")))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryCondition.pageNum,
                  "page-sizes": _vm.pageSizeList,
                  "page-size": _vm.queryCondition.pageSize,
                  layout: _vm.pageLayout,
                  total: _vm.totalCount,
                },
                on: {
                  "size-change": _vm.pageSizeChange,
                  "current-change": _vm.pageNumberChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "userInfo_dialog",
          attrs: {
            title: _vm.$t("sys.userList.userInfo"),
            visible: _vm.showUserInfo,
            width: "70%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showUserInfo = $event
            },
            closed: _vm.closeUserInfo,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "userInfoForm",
              attrs: {
                model: _vm.userInfo,
                rules: _vm.userRules,
                "label-position": _vm.labelPosition,
                "label-width": "100px",
              },
            },
            [
              _c("div", { staticClass: "title_box" }, [
                _c("p", { staticClass: "line" }),
                _c("p", { staticClass: "title" }, [_vm._v("用户信息")]),
              ]),
              _c(
                "div",
                { staticClass: "user_info" },
                [
                  _c(
                    "div",
                    { staticClass: "personal_img" },
                    [
                      _c("el-avatar", {
                        attrs: { size: 300, src: _vm.imageUrl },
                      }),
                      _c(
                        "el-upload",
                        {
                          ref: "upload",
                          staticClass: "avatar-uploader",
                          attrs: {
                            action: _vm.fileUploadUrl(_vm.userInfo.tmUserId),
                            "show-file-list": false,
                            "on-success": (response, file, fileList) =>
                              _vm.uploadSuccess(
                                _vm.userInfo.tmUserId,
                                response,
                                file,
                                fileList
                              ),
                            headers: _vm.header,
                            "before-upload": _vm.beforeAvatarUpload,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "el-icon-upload searhBtn",
                              attrs: { size: "small", type: "primary" },
                            },
                            [_vm._v("上传电子签名")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "用户名", prop: "name" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.userInfo.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.userInfo, "name", $$v)
                                  },
                                  expression: "userInfo.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "用户账号", prop: "emplid" } },
                            [
                              _c("el-input", {
                                attrs: { disabled: "", placeholder: "请输入" },
                                model: {
                                  value: _vm.userInfo.emplid,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.userInfo, "emplid", $$v)
                                  },
                                  expression: "userInfo.emplid",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "手机号", prop: "phone" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.userInfo.phone,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.userInfo, "phone", $$v)
                                  },
                                  expression: "userInfo.phone",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "邮箱", prop: "email" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.userInfo.email,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.userInfo, "email", $$v)
                                  },
                                  expression: "userInfo.email",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "语言",
                                prop: "userWorkLanguage",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { clearable: "" },
                                  model: {
                                    value: _vm.userInfo.userWorkLanguage,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.userInfo,
                                        "userWorkLanguage",
                                        $$v
                                      )
                                    },
                                    expression: "userInfo.userWorkLanguage",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("common.sel"),
                                      value: "",
                                    },
                                  }),
                                  _c("el-option", {
                                    key: "1",
                                    attrs: { value: "zh_CN", label: "中文" },
                                  }),
                                  _c("el-option", {
                                    key: "2",
                                    attrs: { value: "en_US", label: "英文" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Leader" } },
                            [
                              _c("pickup-user", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "default-value": _vm.userInfo.leaderName,
                                },
                                on: { change: _vm.changeLeader },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "供应商Code",
                                prop: "supplierCode",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.userInfo.supplierCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.userInfo, "supplierCode", $$v)
                                  },
                                  expression: "userInfo.supplierCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "所属实验室",
                                prop: "laboratory",
                              },
                            },
                            [
                              _c("ic-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  table: "TM_USER",
                                  field: "LABORATORY",
                                },
                                model: {
                                  value: _vm.userInfo.laboratory,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.userInfo, "laboratory", $$v)
                                  },
                                  expression: "userInfo.laboratory",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      this.emplFlag === "MCD"
                        ? _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "QIP_DC", prop: "dcCodes" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        clearable: "",
                                        multiple: "",
                                        placeholder: "请选择(支持多选)",
                                      },
                                      model: {
                                        value: _vm.userInfo.dcCodes,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.userInfo, "dcCodes", $$v)
                                        },
                                        expression: "userInfo.dcCodes",
                                      },
                                    },
                                    _vm._l(
                                      _vm.QipcdList,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.label,
                                            value: item.value,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.emplFlag === "SUP"
                ? _c("div", { staticClass: "title_box" }, [
                    _c("p", { staticClass: "line" }),
                    _c("p", { staticClass: "title" }, [_vm._v("数据权限")]),
                  ])
                : _vm._e(),
              _vm.emplFlag === "SUP"
                ? _c(
                    "div",
                    { staticClass: "user_info" },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c("el-col", [
                            _c("table", { staticClass: "user_table" }, [
                              _c("tr", [
                                _c("td", { staticClass: "title" }, [
                                  _vm._v("模块"),
                                ]),
                                _c("td", { staticClass: "title" }, [
                                  _vm._v("权限值"),
                                ]),
                              ]),
                              _c("tr", [
                                _c("td", [_vm._v("HGS供应商、RMC采购量")]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { "label-width": "0" } },
                                      [
                                        _c("ic-select", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            table: "TM_USER",
                                            field: "DATA_SCOPE",
                                            clearable: "",
                                          },
                                          model: {
                                            value: _vm.userInfo.dataScope,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.userInfo,
                                                "dataScope",
                                                $$v
                                              )
                                            },
                                            expression: "userInfo.dataScope",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("tr", [
                                _c("td", [_vm._v("StoreFeedBack")]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { "label-width": "0" } },
                                      [
                                        _c("ic-select", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            table: "TM_USER",
                                            field: "DATA_SCOPE_TYPE_FEEDBACK",
                                            clearable: "",
                                          },
                                          model: {
                                            value:
                                              _vm.userInfo.feedBackDataScope,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.userInfo,
                                                "feedBackDataScope",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "userInfo.feedBackDataScope",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("tr", [
                                _c("td", [_vm._v("Sensory")]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { "label-width": "0" } },
                                      [
                                        _c("ic-select", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            table: "TM_USER",
                                            field: "DATA_SCOPE_TYPE_SENSORY",
                                            clearable: "",
                                          },
                                          model: {
                                            value:
                                              _vm.userInfo.sensoryDataScope,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.userInfo,
                                                "sensoryDataScope",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "userInfo.sensoryDataScope",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("tr", [
                                _c("td", [_vm._v("Nutrition")]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { "label-width": "0" } },
                                      [
                                        _c("ic-select", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            table: "TM_USER",
                                            field: "NUTRITION_DATA_SCOPE",
                                            clearable: "",
                                          },
                                          model: {
                                            value:
                                              _vm.userInfo.nutritionDataScope,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.userInfo,
                                                "nutritionDataScope",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "userInfo.nutritionDataScope",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "5px" },
                  attrs: { type: "flex", justify: "center" },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.showUserInfo = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.close")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.saveUserInfo },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.save")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("sys.userList.roleSelection"),
            visible: _vm.showUserRole,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showUserRole = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c("el-transfer", {
                staticStyle: { "text-align": "left", display: "inline-block" },
                attrs: {
                  filterable: "",
                  data: _vm.notSelRoles,
                  titles: [
                    _vm.$t("sys.userList.roleSource"),
                    _vm.$t("sys.userList.roleTarget"),
                  ],
                },
                model: {
                  value: _vm.selRoles,
                  callback: function ($$v) {
                    _vm.selRoles = $$v
                  },
                  expression: "selRoles",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer", align: "center" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.showUserRole = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.close")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveUserRole } },
                [_vm._v(_vm._s(_vm.$t("common.save")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }